<div class="list-group">
    <div
            *ngFor="let count of widgetData?.content"
            class="list-group-item"
    >
		<span class="d-flex justify-content-between align-items-center">
      <b> 
        {{
              (count.board?.alias === null ? '' : (count.board?.alias + ' ')) +
              (count?.counter_key === 'total' ? '' : (('WIDGETS.TASK_FILTER.' + count.counter_name?.toLocaleUpperCase())|translate)) + ' ' +
              (((count.counter_key?.label? count.counter_key.label : 'WIDGETS.TASK_FILTER.' +   count.counter_key?.toLocaleUpperCase())|translate))
          }}:
      </b>
            {{ count.count }}
		</span>
    </div>
</div>